export const bankingConst = {
  path: "/single-programs/banking",
  title: "ФАКУЛЬТЕТ БИЗНЕСА – БАНКОВСКОЕ ДЕЛО",
  contentJSX: (
    <>
      <p>
        <strong>Диплом: </strong>бакалавра / магистра
      </p>
      <p>
        <strong>Формы обучения: </strong>очно или дистанционно
      </p>
      <p>
        <strong>Форма связи: </strong>Получить консультацию приемной комиссии
      </p>
      <h2>Банковское дело — основа финансовой стабильности и развития экономики</h2>
      <p>
        Банковская система — это сердце экономической жизни любой страны. Специалисты в этой сфере управляют денежными потоками,
        обеспечивают кредитование бизнеса и населения, помогают инвестировать и сохранять средства.
      </p>
      <p>
        Современное банковское дело — это синтез классических финансов и цифровых технологий. Мы готовим экспертов, способных адаптироваться
        к вызовам рынка, быстро принимать решения и работать с инновационными финансовыми продуктами.
      </p>
      <h2>Что вы будете изучать?</h2>
      <ul>
        <li>Основы банковской деятельности</li>
        <li>Кредитование физических и юридических лиц</li>
        <li>Управление банковскими рисками</li>
        <li>Банковский менеджмент и маркетинг</li>
        <li>Международные расчеты и валютные операции</li>
        <li>Финансовый анализ и оценка платежеспособности</li>
        <li>Финансовые технологии (FinTech) и цифровые банковские сервисы</li>
        <li>Блокчейн и криптовалюты в банковской сфере</li>
        <li>Законодательство и регулирование в ЕС</li>
      </ul>
      <p>Обучение включает разбор реальных кейсов, симуляции банковских процессов и стажировки в финансовых учреждениях Европы.</p>
      <h2>Кем можно работать после окончания?</h2>
      <ul>
        <li>Специалист в коммерческом банке</li>
        <li>Кредитный аналитик</li>
        <li>Специалист по работе с корпоративными клиентами</li>
        <li>Консультант по инвестициям и личным финансам</li>
        <li>Менеджер по рискам или управлению активами</li>
        <li>Специалист по банковским ИТ-решениям</li>
        <li>Сотрудник международных финансовых организаций (ECB, EIB и др.)</li>
      </ul>
      <h2>Средний доход в Европе:</h2>
      <p>
        от <strong>€50,000 до €85,000 в год,</strong> в зависимости от уровня и направления карьеры.
      </p>
      <h2>Почему выбирают нас?</h2>
      <ul>
        <li>Европейский диплом, признанный в банковской системе ЕС</li>
        <li>Актуальные программы: классическое банковское дело + цифровые финансы</li>
        <li>Стажировки и практика в банках и финтех-компаниях</li>
        <li>Обучение на русском или английском языке</li>
        <li>Поддержка в трудоустройстве и карьерном росте</li>
        <li>Возможность выбрать очную или дистанционную форму обучения</li>
      </ul>
      <p>Банковское дело — это престиж, стабильность и реальные перспективы для профессионального и финансового роста.</p>
      <h2>Как поступить?</h2>
      <p>
        Подача заявки — это первый шаг к успешной международной карьере. Приёмная комиссия поможет вам подобрать нужную программу и пройти
        все этапы поступления без стресса.
      </p>
    </>
  ),
  contentSearch: `
    Диплом: бакалавра / магистра
    Формы обучения: очная или дистанционная
    Форма связи: Получить консультацию приемной комиссии
    Банковское дело — основа финансовой стабильности и развития экономики
    Банковская система — это сердце экономической жизни любой страны. Специалисты в этой сфере управляют денежными потоками, обеспечивают кредитование бизнеса и населения, помогают инвестировать и сохранять средства.
    Современное банковское дело — это синтез классических финансов и цифровых технологий. Мы готовим экспертов, способных адаптироваться к вызовам рынка, быстро принимать решения и работать с инновационными финансовыми продуктами.

    Что вы будете изучать?
    • Основы банковской деятельности
    • Кредитование физических и юридических лиц
    • Управление банковскими рисками
    • Банковский менеджмент и маркетинг
    • Международные расчеты и валютные операции
    • Финансовый анализ и оценка платежеспособности
    • Финансовые технологии (FinTech) и цифровые банковские сервисы
    • Блокчейн и криптовалюты в банковской сфере
    • Законодательство и регулирование в ЕС
    Обучение включает разбор реальных кейсов, симуляции банковских процессов и стажировки в финансовых учреждениях Европы.

    Кем можно работать после окончания?
    • Специалист в коммерческом банке
    • Кредитный аналитик
    • Специалист по работе с корпоративными клиентами
    • Консультант по инвестициям и личным финансам
    • Менеджер по рискам или управлению активами
    • Специалист по банковским ИТ-решениям
    • Сотрудник международных финансовых организаций (ECB, EIB и др.)

    Средний доход в Европе:
    от €50,000 до €85,000 в год, в зависимости от уровня и направления карьеры.

    Почему выбирают нас?
    • Европейский диплом, признанный в банковской системе ЕС
    • Актуальные программы: классическое банковское дело + цифровые финансы
    • Стажировки и практика в банках и финтех-компаниях
    • Обучение на русском или английском языке
    • Поддержка в трудоустройстве и карьерном росте
    • Возможность выбрать очную или дистанционную форму обучения

    Банковское дело — это престиж, стабильность и реальные перспективы для профессионального и финансового роста.

    Как поступить?
    Подача заявки — это первый шаг к успешной международной карьере.
    Приёмная комиссия поможет вам подобрать нужную программу и пройти все этапы поступления без стресса.
  `,
};
